<template>
  <hr :class="[classes]" :aria-orientation="orientation" :role="role">
</template>

<script>

export default {
  name: 'VDivider',
  data() {
    return {
      orientation: '',
      role: 'separator',
    };
  },
  props: {
    inset: Boolean,
    vertical: Boolean,
  },
  computed: {
    classes() {
      return {
        'v-divider': true,
        'v-divider--inset': this.inset,
        'v-divider--vertical': this.vertical,
      };
    },
  },
  methods: {
    calcOrientation() {
      if (!this.role || this.role === 'separator') {
        this.orientation = this.vertical ? 'vertical' : 'horizontal'
      }
    }
  },
  mounted() {
    this.calcOrientation();
  }
};
</script>

<style lang="scss" scoped>
@import "VDivider";
</style>
